export default __webpack_public_path__ + "images/02a88e7e583cc1cca1fa9c08845c0255-Sample-Screenshot.jpg";